<template>
  <v-container fluid>
    <v-card raised elevation="5" style="width: 100%">
      <v-card-text>
        <v-row v-resize="onResize">
          <ejs-splitter
            id="splitter"
            ref="splitterObj"
            :separatorSize="3"
            class="splitterContent"
            width="100%"
          >
            <e-panes>
              <e-pane
                size="30%"
                :collapsible="false"
                :collapsed="false"
                content="#user-list-content"
                min="20%"
              ></e-pane>
              <e-pane
                cssClass="overflow-hidden"
                size="70%"
                min="50%"
                content="#user-permission-content"
              ></e-pane>
            </e-panes>
          </ejs-splitter>
          <v-card flat id="user-list-content" style="text-align: left">
            <v-toolbar color="neutralGray" dark height="56px" flat tile>
              <v-icon dark size="26">mdi-account-supervisor</v-icon>
              <span style="margin-left: 5px" class="text-h6">{{
                $t("admin.lblRegisteredUsers")
              }}&nbsp; : &nbsp;{{ filteredItems.length }}</span>
            </v-toolbar>
            <v-card-title
              class="paler-bg"
              style="
                background-color: var(--v-appBar-base);
                border-bottom: solid 1px var(--v-appBar-darken2);
              "
            >
              <a-text-field
                v-model="search"
                prepend-inner-icon="mdi-account-search"
                :label="$t('agenda.lblEmailAddress')"
                dense
                single-line
                hide-details
                clearable
              ></a-text-field>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="ml-2"
                    color="primaryDark"
                    dark
                    x-small
                    right
                    fab
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="openUserDialog(false)"
                  >
                    <v-icon>mdi-account-plus</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("admin.newUser") }}</span>
              </v-tooltip>
              <add-user
                v-if="dialog"
                v-model="dialog"
                :data="userForm"
                :is-edit="isEdit"
                :user-emails="userEmails"
                @saveUser="onSuccess"
              ></add-user>
            </v-card-title>
            <user-list
              v-model="selectedUserId"
              :users-list="filteredItems"
              :screenHeight="screenHeight"
            ></user-list>
          </v-card>
          <v-card id="user-permission-content" style="text-align: left" flat>
            <v-toolbar color="secondary" height="56px" flat tile>
              <v-icon size="26">mdi-account-details</v-icon>
              <span style="margin-left: 5px" class="text-h6">{{
                $t("admin.userPermissions")
              }}</span>
              <v-spacer></v-spacer>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <a-btn
                    v-bind="attrs"
                    v-on="on"
                    color="primaryDark"
                    @click.stop="openUserDialog(true)"
                    :disabled="!selectedUserId"
                  >
                    <v-icon small>mdi-pencil</v-icon>{{ $t("admin.editUser") }}
                  </a-btn>
                </template>
                <span>{{ $t("admin.tipEditUser") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <a-btn
                    v-bind="attrs"
                    v-on="on"
                    color="primaryDark"
                    @click.stop="ConfirmRemoveUser()"
                    class="ml-2"
                    :disabled="!selectedUserId"
                  >
                    <v-icon small>mdi-delete</v-icon>
                    {{ $t("admin.removeUser") }}
                  </a-btn>
                </template>
                <span>{{ $t("admin.removeUser") }}</span>
              </v-tooltip>
            </v-toolbar>
            <v-list class="pa-0 paler-bg">
              <v-list-item>
                <v-list-item-avatar tile size="45" color="pageHeader">
                  <v-img
                    v-if="selectedUserId && selectedUser.profilePhoto"
                    :src="selectedUser.profilePhoto"
                  ></v-img>
                  <v-img v-else src="@/assets/images/NoPhotoIcon.png"></v-img>
                </v-list-item-avatar>

                <v-list-item-content v-if="selectedUser">
                  <v-list-item-title v-if="selectedUserId && selectedUser">
                    <h5 v-if="selectedUser.firstName">
                      {{ selectedUser.firstName + " " + selectedUser.lastName }}
                    </h5>
                    <h5 v-else>{{ selectedUser.registered_email }}</h5>
                  </v-list-item-title>

                  <v-list-item-subtitle
                    class="caption"
                    v-if="selectedUser.firstName"
                    >{{ $t("lblEmail") }}:
                    {{
                      selectedUserId && selectedUser
                        ? selectedUser.registered_email
                        : ""
                    }}</v-list-item-subtitle
                  >
                </v-list-item-content>
                <v-list-item-action>
                <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <a-btn
                    v-bind="attrs"
                    v-on="on"
                    color="primaryDark"
                    x-small
                    :disabled="!selectedUserId"
                    @click="resetMFA(selectedUserId)"
                    >{{ $t("admin.btnResetMFA") }}</a-btn
                  >
                </template>
                <span>{{ $t("admin.btnResetMFA") }}</span>
              </v-tooltip>
              </v-list-item-action>
              </v-list-item>
            </v-list>

            <v-divider></v-divider>
            <v-card-text
              class="paler-bg"
              v-if="selectedUser"
              style="background-color: var(--v-appBar-base)"
              >{{ $t("admin.lblPermissionSetForUser") }}
            </v-card-text>
            <v-tabs
              class="a-tabs role-tabs"
              show-arrows
              height="38"
              style="background-color: var(--v-Neutral-base)"
              right
              v-model="userRoleTabIndex"
              @change="onRoleTabChange"
            >
              <v-tabs-slider color="primary"></v-tabs-slider>
              <v-tab class="ml-2"> {{ $t("admin.lblGeneralRoles") }} </v-tab>
              <v-tab> {{ $t("admin.lblMeetingBasedRoles") }} </v-tab>
            </v-tabs>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-tabs-items v-model="currentTab">
                  <v-tab-item>
                    <div class="mx-5 my-2">
                      <v-list-item-subtitle class="caption"
                        >{{ $t("admin.role") }}:
                        <span v-if="selectedUserId && selectedUser">
                          <template v-for="role in selectedUser.roles">
                            <v-chip
                              x-small
                              color="primary"
                              class="ml-3"
                              :key="role"
                            >
                              {{ getRoleName(role) }}
                            </v-chip>
                          </template>
                        </span>
                      </v-list-item-subtitle>
                    </div>
                    <v-divider></v-divider>
                    <module-permission
                      v-model="permissionList"
                      :disabled="true"
                      :permissionsList="permissionsList"
                    ></module-permission>
                  </v-tab-item>
                  <v-tab-item>
                    <div class="meeting-rolelist">
                      <meeting-type-assign-role-table
                        v-model="selectedMeetingType"
                        :roleAssignedList="roleAssignedList"
                        @roelSelect="onRoleSelect"
                      ></meeting-type-assign-role-table>
                      <module-permission
                        v-model="permissionList"
                        :disabled="true"
                        :permissionsList="permissionsList"
                        :isContainerClass="currentTab == 0 ? true : false"
                      ></module-permission>
                    </div>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
            <v-divider></v-divider>
          </v-card>
        </v-row>
      </v-card-text>
      <MessageSheet
        :showMessage="displayMessage"
        :message="message"
        :messageType="messageType"
        @close="displayMessage = false"
      ></MessageSheet>
      <ConfirmDlg ref="confirm" :hasTimer="true" :userName="selectedUser.firstName + ' ' + selectedUser.lastName" />
    </v-card>
  </v-container>
</template>
<script>
import MessageSheet from "@/components/MessageSheet.vue";
import customFunctions from "@/codeFiles/taskHelper.js";
import ConfirmDlg from "@/components/ConfirmDialog.vue";
import AuthService from "@/codeFiles/auth/auth.service.js";
import graphConfig from "@/codeFiles/auth/graphConfig.js";
import { createUUID } from "../../utils/util";
import { mapActions, mapGetters, mapState } from "vuex";
import UserList from "./UserList.vue";
import UserPermission from "./UserPermission.vue";
import _ from "lodash";
import AddUser from "./AddUser.vue";
import ModulePermission from "./ModulePermission.vue";
import SignalRMixin from "../../mixin/SignalRMixin";
import Loader from "@/components/Loader";
import MeetingTypeAssignRoleTable from "./MeetingTypeAssignRoleTable.vue";
import adminService from "../../api/adminService";

export default {
  name: "UserManagement",
  mixins: [SignalRMixin],
  data() {
    return {
      generalPermissionList: [],
      selectedMeetingType: [],
      roleAssignedList: [],
      currentTab: 0,
      userRoleTabIndex: 0,
      selectedUserId: null,
      screenHeight: 0,
      permissionList: [],
      dataloading: false,
      page: 1,
      pageCount: 0,
      search: "",
      dialog: false,
      items: [],
      roles: [],
      ActionsList: [],
      disableMessage: false,
      displayMessage: false,
      message: "",
      messageType: "",
      valid: false,
      rules: [(v) => !!v || "This field is mandatory"],
      selected: {
        Id: "",
        UserID: "",
        role: "",
        displayName: "",
        permissions: [],
      },
      // selectedUser: null,
      Role: "",
      UserID: "",
      isEdit: false,
      Contacts: [],
      rolePermissions: [],
      userForm: {
        id: null,
        tenantid: sessionStorage.getItem("tenantId"),
        firstName: "",
        lastName: "",
        registered_email: "",
        //display_email: "",
        roles: [],
        tenantname: "",
        user_id: "",
        createdBy: this.$auth.user.email,
        createdDate: new Date().toISOString(),
        contactEmailIds: [""],
        meeting_type_roles: [],
      },
      refUserForm: {
        id: null,
        tenantid: sessionStorage.getItem("tenantId"),
        firstName: "",
        lastName: "",
        user: "",
        roles: [],
        tenantname: "",
        user_id: "",
        resetMFAToken: null,
        createdBy: this.$auth.user.email,
        createdDate: new Date().toISOString(),
        contactEmailIds: [""],
        meeting_type_roles: [],
      },
      emailRules: [
        (v) => !!v || this.$t("ruleEmailReq"),
        (v) => /.+@.+\..+/.test(v) || this.$t("ruleEmailvalid"),
      ],
    };
  },
  components: {
    MessageSheet,
    ConfirmDlg,
    UserList,
    UserPermission,
    AddUser,
    ModulePermission,
    Loader,
    MeetingTypeAssignRoleTable,
  },

  async created() {
    this.authService = new AuthService();
    this.user = this.authService.app.getAccount();
    if (this.$store.state.Contacts.length > 0) {
      this.Contacts = this.$store.state.Contacts;
    }
  },
  computed: {
    ...mapState({
      roleList: (state) => state.admin.roleList,
      userList: (state) => state.admin.userList,
      userDetails: (state) => state.admin.userDetails,
    }),
    ...gettersMap(),

    selectedUser() {
      return this.userDetails;
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    saveDisabled(val) {
      return !this.valid;
    },
    tenantId() {
      return sessionStorage.getItem("tenantId");
    },
    LoaderText() {
      return this.$t("LoaderText");
    },
    userEmails() {
      const emails = [];
      this.userList.forEach((user) => {
        if (user.registered_email && user.is_registered_user === true) {
          if (user.contactEmailIds && user.contactEmailIds.length > 0) {
            user.contactEmailIds.forEach((element) => {
              if (element) {
                emails.push({
                  id: user.id,
                  display_email: element.toLowerCase().trim(),
                  registered_email: element.toLowerCase().trim(),
                  firstName: user.firstName,
                  lastName: user.lastName,
                  contactEmailIds: user.contactEmailIds,
                });
              }
            });
          }
        }
      });
      return emails;
    },
    filteredItems() {
      return _.orderBy(
        this.userList.filter((item) => {
          if (!this.search) return this.userList;
          return (
            item.registered_email &&
            item.registered_email
              .toLowerCase()
              .includes(this.search.toLowerCase())
          );
        })
      );
    },
    generalPermissions() {
      return this.masterSettingTypes("general_permissions");
    },
    meetingTypePermissions() {
      return this.masterSettingTypes("meeting_type_permissions");
    },
    permissionsList() {
      if (this.userRoleTabIndex === 0) {
        return this.generalPermissions;
      }
      return this.meetingTypePermissions;
    },
  },
  mounted,
  watch: {
    async selectedUser(value) {
      if (value) {
        this.userRoleTabIndex = 0;
        this.currentTab = 0;
        this.permissionList = [];
        const result = this.roleList.filter((elem) =>
          value.roles.find((role) => elem.id === role)
        );
        const permissions = result.map((r) => r.permissions);
        let mergePermissionList = [];

        permissions.forEach((element) => {
          mergePermissionList = mergePermissionList.concat(element);
        });
        if (value.meeting_type_roles) {
          const meetingTypePemissionData = value.meeting_type_roles.map(
            (roleType) => {
              return {
                meeting_type_id: roleType.meeting_type_id,
                role_id: roleType.role_id,
                meetingType: this.getMettingTypeName(roleType.meeting_type_id),
                role: this.getMeetingRoleName(roleType.role_id),
              };
            }
          );

          this.roleAssignedList = meetingTypePemissionData.filter(
            (m) => m.meetingType !== null && m.role !== null
          );
        } else {
          this.roleAssignedList = [];
          this.selectedMeetingType = [];
        }
        this.permissionList = [...new Set(mergePermissionList)];
        this.generalPermissionList = this.permissionList;
      }
    },
    async selectedUserId(id) {
      if (id) {
        await this.getUserDetailsById(id);
      }
    },
  },
  methods: {
    ...mapActions({
      createUser: "admin/createUser",
      getRoleList: "admin/getRoleList",
      getRoleById: "admin/getRoleById",
      createTenantConfig: "tenant/createTenantConfig",
      deleteUserAction: "admin/deleteUser",
      getUserById: "admin/getUserById",
      getUserList: "admin/getUserList",
      clearUserList: "admin/clearUserList",
      getUpdatedUserList: "people/getUpdatedUserList",
    }),
    selectUser,
    openUserDialog,
    showMessageSheet,
    close,
    SaveUser,
    ConfirmRemoveUser,
    getPhoto,
    onResize,
    getUserDetailsById,
    onSuccess,
    onRoleTabChange,
    signalRInit,
    getMettingTypeName,
    getMeetingRoleName,
    onRoleSelect,
    getSelectedMeetingTypeRolePermission,
    getRoleName,
    async resetMFA(selectedUserId) {
      try {
        // First call initiateResetMFA API
        const initiateResponse = await adminService.initiateResetMFA(selectedUserId);
        
        if (initiateResponse && initiateResponse.data && initiateResponse.data.token) {
          // Store the token for later use
          this.resetMFAToken = initiateResponse.data.token;
          
          // Open confirm dialog with timer
          const confirmed = await this.$refs.confirm.open(
            this.$t("lblConfirm"),
            this.$t("admin.resetMFAConfirm"),
            { hasTimer: true } // Pass hasTimer option to dialog
          );
          
          if (confirmed) {
            // If user clicked OK, call the actual resetMFA API with token
            const resetResponse = await adminService.resetMFA({
              token: this.resetMFAToken
            });
            
            if (resetResponse) {
              this.showMessageSheet(this.$t("admin.resetMFAMessage"), "success");
            }
          }
        }
      } catch (error) {
        console.error("Error during MFA reset:", error);
        this.showMessageSheet("Error resetting MFA", "error");
      } finally {
        // Clean up token
        this.resetMFAToken = null;
      }
    }
  },
};

function onRoleSelect(item) {
  this.getSelectedMeetingTypeRolePermission(item.role_id);
}

function getSelectedMeetingTypeRolePermission(roleId) {
  let rolePermission = this.roleList.find((r) => r.id === roleId);
  if (rolePermission) {
    this.permissionList = rolePermission.permissions;
  } else {
    this.permissionList = [];
  }
}

function getMettingTypeName(id) {
  const meetingTypes = this.meetingTypes.find((t) => t.id === id);
  if (meetingTypes) {
    return meetingTypes.label;
  }
  return null;
}

function getMeetingRoleName(id) {
  const data = this.roleList.find(
    (t) => t.id === id && t.role_type === "meeting_type"
  );
  if (data) {
    return data.role;
  }
  return null;
}

function getRoleName(id) {
  const data = this.roleList.find((t) => t.id === id);
  if (data) {
    return data.role;
  }
  return null;
}

async function signalRInit() {
  let target = `admin_${this.selectedTenant}`;
  this.signalConnection.on(target, async (message) => {
    const result = JSON.parse(message);
    if (result) {
      await this.getRoleList();
      await this.getUserList();
      await this.getUpdatedUserList();
      if (this.userList.length && this.selectedUserId) {
        await this.getUserDetailsById(this.selectedUserId);
      }
    }
  });
  if (this.signalConnection.connectionState.toLowerCase() === "disconnected") {
    this.signalConnection.start().catch();
  }
}

function onRoleTabChange() {
  this.currentTab = this.userRoleTabIndex;
  if (this.currentTab === 1) {
    if (this.roleAssignedList.length) {
      this.selectedMeetingType = [];
      this.selectedMeetingType.push(this.roleAssignedList[0]);
      this.getSelectedMeetingTypeRolePermission(
        this.roleAssignedList[0].role_id
      );
    } else {
      this.permissionList = [];
    }
  } else {
    this.permissionList = this.generalPermissionList;
  }
}

async function getUserDetailsById(id) {
  await this.getUserById(id);
}

function onResize() {
  this.screenHeight = window.innerHeight - 280;
}
async function mounted() {
  if (this.userList.length) {
    await this.getUserDetailsById(this.userList[0].id);
  }
  await this.signalRInit();
}

function selectUser(item) {
  this.selected = Object.assign({}, item);
  this.getPhoto(item.id, "selectedUserPhoto");
  //fetch actions from List of roles
  this.selected.permissions = this.rolePermissions.find(
    (a) => a.roleTitle === this.selected.role
  ).permissions;
}

async function openUserDialog(isEdit) {
  this.isEdit = isEdit;

  if (isEdit && this.selectedUserId) {
    try {
      const data = await this.getUserById(this.selectedUserId);
      const cIds =
        data.contactEmailIds && data.contactEmailIds.length > 0
          ? data.contactEmailIds.filter(
              (email) => email !== data.registered_email
            )
          : [""];
      data.contactEmailIds = cIds.length > 0 ? cIds : [""];

      this.userForm = _.cloneDeep(data);
      this.userForm.user_id = data.user_id || "";
    } catch (error) {
      console.log(error, "user management")
    }
  } else {
    this.userForm = _.cloneDeep(this.refUserForm);
  }
  this.dialog = true;
}

function showMessageSheet(message, messageType) {
  this.displayMessage = true;
  this.message = message;
  this.messageType = messageType;
}

function close() {
  this.$refs.refUserForm.resetValidation();
  this.$refs.refUserForm.reset();
  this.dialog = false;
}

async function SaveUser() {
  try {
    this.displayMessage = false;
    if (this.$refs.refUserForm.validate()) {
      this.userForm.tenantname = "";
      const users = this.$auth.user[process.env.VUE_APP_TENANT_KEY];
      const tenant = users.find((u) => u.id === this.tenantId);
      if (tenant) {
        this.userForm.tenantname = tenant.name;
      }
      this.userForm.id = createUUID();
      await this.createUser(this.userForm);
    }
  } catch (error) {
    console.log(error, "user management")
  }
}

async function ConfirmRemoveUser() {
  if (!this.selectedUserId) {
    return;
  }
  if (
    await this.$refs.confirm.open(
      this.$t("admin.confirmUserDeletion"),
      this.$t("admin.userDeletionMessage")
    )
  ) {
    this.deleteUserAction(this.selectedUser.id)
      .then((response) => {
        if (response == "OK") {
          this.showMessageSheet(
            this.$t("admin.msgUserDeleteSuccess"),
            "success"
          );
        }
      })
      .catch((error) => {
        console.log(error, "user management")
      });
  }
}

async function getPhoto(userPrincipalName, imgID) {
  var icon_elem = document.getElementById(imgID);
  icon_elem.src = "../assets/images/excalibur.png";
}

function gettersMap() {
  return mapGetters({
    tenantSettingConfig: "tenant/tenantSettingConfig",
    tenantSettingTypes: "tenant/tenantSettingTypes",
    masterSettingTypes: "tenant/masterSettingTypes",
    meetingTypes: "tenant/agendaMeetingTypes",
  });
}

function onSuccess() {
  this.isEdit
    ? this.showMessageSheet(this.$t("admin.msgUserUpdateSuccess"), "success")
    : this.showMessageSheet(this.$t("admin.msgUserCreateSuccess"), "success");
}
</script>


<style scoped>
.role-tabs {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}
.role-tabs .v-tab--active {
  background: #dde3ee;
}
.paler-bg {
  background: #f5f5f5 !important;
}

::v-deep .v-pagination__item {
  height: 20px;
  font-size: 0.8rem;
  min-width: 20px !important;
}

::v-deep .v-pagination__navigation {
  width: 20px;
  height: 20px;
}

::v-deep .v-card__text {
  width: 100%;
  padding: 12px !important;
}

/* default split bar color */
::v-deep .e-splitter .e-split-bar.e-split-bar-horizontal {
  background: var(--v-pageHeader-lighten2);
  z-index: 1 !important;
  width: 1px !important;
  margin-left: 1px;
  margin-right: 1px;
}
.splitterContent
  /deep/
  .e-split-bar.e-split-bar-horizontal.e-resizable-split-bar::after {
  width: 4px !important;
}
/* split bar color in hover and active state */
::v-deep .e-splitter .e-split-bar.e-split-bar-horizontal.e-split-bar-hover,
.e-splitter .e-split-bar.e-split-bar-horizontal.e-split-bar-active {
  background: var(--v-pageHeader-base);
}

/* default split bar resize handle color */
::v-deep .e-splitter .e-split-bar.e-split-bar-horizontal .e-resize-handler {
  color: var(--v-pageHeader-base);
}

/* default split bar resize handle color in hover and active state */
::v-deep
  .e-splitter
  .e-split-bar.e-split-bar-horizontal.e-split-bar-hover
  .e-resize-handler,
.e-splitter
  .e-split-bar.e-split-bar-horizontal.e-split-bar-active
  .e-resize-handler {
  color: var(--v-pageHeader-base);
}

/* split bar arrows - circular border */
::v-deep
  .e-splitter
  .e-split-bar.e-split-bar-horizontal.e-split-bar-hover
  .e-navigate-arrow.e-arrow-left {
  background-color: var(--v-pageHeader-lighten2) !important;
  opacity: initial;
}

::v-deep
  .e-splitter
  .e-split-bar.e-split-bar-horizontal.e-split-bar-hover
  .e-navigate-arrow.e-arrow-right {
  background-color: var(--v-pageHeader-lighten2) !important;
  opacity: initial;
}
/* split bar arrows */

::v-deep
  .e-splitter
  .e-split-bar.e-split-bar-horizontal
  .e-navigate-arrow.e-arrow-right {
  background-color: var(--v-pageHeader-lighten3) !important;
  opacity: 0.2;
}

::v-deep .e-splitter.e-splitter-horizontal .e-pane.e-scrollable,
.e-splitter.e-splitter-vertical .e-pane.e-scrollable {
  /* overflow: unset !important; */
}

.user-list {
  /*height: 300px;*/ /* or any height you want */
  height: calc(100vh - 365px);
  overflow-y: auto;
  margin-left: 20px;
}

.meeting-rolelist {
  /*height: 300px;*/ /* or any height you want */
  height: calc(100vh - 365px);
  overflow-y: auto;
  margin-left: 20px;
}
</style>
